export default __webpack_public_path__ + "static/media/mcs_analytics.5e7a6387.png";